// eslint-disable-next-line
const isNumber = (o: any) => {
  const s = String(o);
  return !Number.isNaN(+s) && Number.isFinite(+s) && (typeof o === 'number' || !/e/i.test(s));
};
export default isNumber;
